<script setup lang="ts">
import type { NovaBoxPostCommentsTypes } from './NovaBoxPostComments.types'

defineProps<NovaBoxPostCommentsTypes>()
</script>

<template>
  <section class="post-comments-wrap">
    <NovaDivider />

    <div class="post-comments">
      <NovaBoxPostCommentAdd />

      <NovaBoxPostCommentsAndReplies
        :view-type="viewType"
        :cmty-ntt-sn="cmtyNttSn"
        :answer-count="answerCount"
      />
    </div>
  </section>
</template>

<style lang="scss" scoped>
.post-comments-wrap {
  display: flex;
  flex-direction: column;
  gap: 30px;

  .post-comments {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
}
</style>
